// Empty string = same origin; nginx proxies /api/* → backend:8000
const API_URL = process.env.REACT_APP_API_URL || "";

export async function submitLead(data) {
  const response = await fetch(`${API_URL}/api/leads`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.detail || "Submission failed. Please try again.");
  }

  return response.json();
}

export async function fetchLeads() {
  const response = await fetch(`${API_URL}/api/leads`);
  if (!response.ok) throw new Error("Failed to fetch leads.");
  return response.json();
}

export async function verifyLead(token) {
  const response = await fetch(`${API_URL}/api/leads/verify/${token}`);
  if (!response.ok) throw new Error("Invalid QR code.");
  return response.json();
}
